import { ModalProps as ChakraModalProps, Modal as ChakraModal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { CloseButton } from 'components/UI/CloseButton';

type ModalProps = ChakraModalProps & {
  isCloseButton?: boolean;
};

const ModalStyles: ComponentStyleConfig = {
  baseStyle: {
    dialog: {
      borderRadius: 0,
    },
  },
};

const Modal = ({ children, isCloseButton = true, onClose, ...props }: ModalProps) => {
  const renderCloseButton = isCloseButton ? <CloseButton variant="modal" onClick={onClose} /> : null;

  return (
    <ChakraModal onClose={onClose} {...props}>
      <ModalOverlay />
      <ModalContent>
        {renderCloseButton}
        {children}
      </ModalContent>
    </ChakraModal>
  );
};

export { Modal, ModalStyles };
